const { SelectControl } = wp.components;

const SelectAlign = ({ attributes, setAttributes }) => {
  return (
    <SelectControl
      label="Selecione o alinhamento do texto"
      title="Selecione o alinhamento do texto"
      value={attributes.align}
      options={[
        { label: 'Esquerda', value: 'left' },
        { label: 'Centro', value: 'center' },
        { label: 'Direita', value: 'right' },
        { label: 'Esquerda - Centro', value: 'left-center' },
        { label: 'Centro - Esquerda', value: 'center-left' },
      ]}
      onChange={(position) => setAttributes({ align: position })}
    />
  );
};

export default SelectAlign;
